import Image from 'next/image';
import { Button } from '~/components/ui';
import womensWeek from '~/public/womens-week.png';

/**
 * Thematic roadblock
 */
export const ThematicRoadblock = ({
  title,
  text,
  backgroundColor,
  image,
  ctaText,
  ctaLink,
}: {
  /**
   * Title of collection
   */
  title: string;
  /**
   * Text to display (HTML allowed)
   */
  text: string;
  /**
   * Background color
   */
  backgroundColor: string;
  /**
   * Image to display
   */
  image: string;
  /**
   * CTA button text
   */
  ctaText: string;
  /**
   * CTA button link
   */
  ctaLink: string;
}) => {
  return (
    <div
      className="bg-email-capture py-10 sm:py-14"
      style={{ backgroundColor }}
    >
      <div className="flex flex-col items-center sm:mx-auto sm:max-w-screen-lg sm:flex-row sm:gap-x-8">
        <div className="p-4 sm:basis-1/2">
          <Image
            src={image}
            width={640}
            height={480}
            unoptimized
            alt={title}
            className="sm:w-full sm:max-w-screen-sm"
          />
        </div>
        <div className="flex flex-col gap-y-4 p-4 sm:basis-1/2">
          <Image src={womensWeek} alt={title} />
          <div dangerouslySetInnerHTML={{ __html: text }} />
          <Button
            href={ctaLink}
            tertiary
            className="w-full text-center sm:w-fit"
          >
            {ctaText}
          </Button>
        </div>
      </div>
    </div>
  );
};
